import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "subtotal",
    "total",
    "balance",
    "currencyCode",
    "item",
    "discountType",
    "discountValue",
    "currency",
  ];

  updateTotal() {
    let total = this.itemTargets.reduce((acc, item) => {
      const controller = this.application.getControllerForElementAndIdentifier(
        item,
        "invoices--item",
      );
      return acc + controller.total();
    }, 0);

    const discount = Number(this.discountValueTarget.value);
    const discountType = this.discountTypeTarget.value;

    this.subtotalTarget.innerText = total.toFixed(2);

    if (discountType === "percent") {
      total = total * (1 - discount / 100);
    } else if (discountType === "amount") {
      total = total - discount;
    }

    this.totalTargets.forEach((el) => (el.innerText = total.toFixed(2)));
    this.balanceTargets.forEach((el) => (el.innerText = total.toFixed(2)));
    this.setCurrency();
  }

  // Also runs after every total update, so line items added later pick up the currency
  setCurrency() {
    this.currencyCodeTargets.forEach((currency) => {
      currency.innerText = this.currencyTarget.value;
    });
  }
}
